import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import styled from 'styled-components';

interface ButtonProps extends MuiButtonProps {
  fullWidth?: boolean;
  loading?: boolean;
}

const StyledButton = styled(MuiButton)<ButtonProps>`
  position: relative;
  min-width: ${({ fullWidth }) => (fullWidth ? '100%' : '120px')};
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: ${({ size }) =>
    size === 'small'
      ? '6px 16px'
      : size === 'large'
      ? '12px 32px'
      : '8px 24px'};
  
  &.loading {
    pointer-events: none;
    opacity: 0.7;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.palette.action.disabledBackground};
    color: ${({ theme }) => theme.palette.action.disabled};
  }

  ${({ variant, theme }) =>
    variant === 'contained' &&
    `
    &:hover {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
  `}
`;

const Button: React.FC<ButtonProps> = ({
  children,
  loading = false,
  disabled = false,
  ...props
}) => {
  return (
    <StyledButton
      disabled={disabled || loading}
      className={loading ? 'loading' : ''}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button; 